import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Connection } from '../models/connection';
import { Subscription } from '../models/subscription';
import { Topic } from '../models/topic';
import { SubscriptionDataService } from '../services/subscription-data.service';

@Component({
  selector: 'app-subscription',  
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  constructor(private dataService: SubscriptionDataService) { }

  ngOnInit(): void {
  }

  private subscription: Subscription;
  public expandMode: 1;
  public activeOpened: boolean;
  public activeTitle: string;
  public deadLetterOpened: boolean;
  public deadLetterTitle: string;
  public active = false;

  @Input() public connection: Connection;
  @Input() public set model(subscription: Subscription) {
      this.subscription = subscription;
      this.active = subscription !== undefined;
      this.activeTitle = 'Active Messages: ' + this.subscription?.ActiveCount;
      this.deadLetterTitle = 'Dead Letter Messages: ' + this.subscription?.DeadLetterCount;
  }
  public get model() {
    return this.subscription;
  }

  @Output() cancel: EventEmitter<any> = new EventEmitter();

  public onCancel(e): void {
      e.preventDefault();
      this.closeForm();
  }

  public closeForm(): void {
      this.active = false;
      this.cancel.emit();
  }

  public onDelete(event: any) {
    this.refreshMetaDetails();
  }

  public async onPanelChange(event: any) { 
    var items = event as StateItem[];
    items.forEach(it => {
      if (it.id == "1") {
        this.activeOpened = it.expanded;
      } else if (it.id == "2") {
        this.deadLetterOpened = it.expanded;
      }
    });

    this.refreshMetaDetails();
  }

  private async refreshMetaDetails() {
    this.dataService.getEntities(`$filter=ConnectionId eq ${this.connection.Id} and Name eq '${this.model.Name}' and Topic eq '${this.model.Topic}'`)
    .subscribe(r => {
      this.subscription = r.value[0];
      this.activeTitle = 'Active Messages: ' + this.subscription?.ActiveCount;
      this.deadLetterTitle = 'Dead Letter Messages: ' + this.subscription?.DeadLetterCount;
    });    
  }
}

export class StateItem {
  id: string;
  expanded: boolean;
  selected: boolean;
}
